import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ResearchAndReportList } from 'src/app/models/ResearchAndReportList';
import { ApiService } from 'src/app/services/api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/services/notification.service';
 
import { Title } from '@angular/platform-browser';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { ResourcesService } from 'src/app/services/resources.service';

@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.css']
})

export class PersonalInfoComponent implements OnInit {
  email: string = '';
  emailResource: string = '';
  name: string = '';
  why: string = '';
  mobile: string = '';
  deviceInfo: DeviceInfo;
  mobilenumber: string = '';
  invalidmobilenumber: string = '';
  downloadpurpose: string = '';
  requiredfield: string = '';
  invalidemail: string = '';
  reportdownload: string = '';
  home: string = '';
  IsRequiredPersonalInformation: boolean;
  nametxt: string = '';
  emailV = false;
  emailForm = true;
  nameF = false;
  whyF = false;
  mobileF = false;
  mobileForm = true;
  ipAddress = '';
  canDownload: boolean;
  imptempPublicUrl = environment.imptempPublicUrl;
  imgPublicUrl = environment.imgPublicUrl;
  DocTitle = '';
  submitted: boolean;
  destroy$: Subject<boolean> = new Subject<boolean>();
  url: string;
  id: number;
  urlJSON: string | undefined;
  urlSPSS: string | undefined;
  urlCSV: string | undefined;
  urlExcel: string | undefined;
  guid: string;
  type: string;
  constructor(private actRoute: ActivatedRoute, private service: ApiService, private router: Router, private http: HttpClient
    , private deviceService: DeviceDetectorService, private notificationService: NotificationService
    , private Title: Title, private apiRersources: ResourcesService) {
    this.submitted = false;
    this.canDownload = false;
    this.actRoute.params.subscribe(params => {
      this.guid = params["id"] == null ? '' : params["id"] ;
      this.type = params["type"] == null ? '' : params["type"] ;
    });

  }

  /** Custom methods */
  getResearchReportList() {
    this.service.getListTopN('researchreportlist', 0, true, 'GUID', this.guid).pipe(takeUntil(this.destroy$)).subscribe(
      (data: ResearchAndReportList[]) => {
        this.url = data[0]?.ItemFields?.RRLink?.Url.replace(environment.imptempPublicUrl, environment.imgPublicUrl),
          this.DocTitle = data[0]?.ItemFields?.RRName,
          this.IsRequiredPersonalInformation = data[0]?.ItemFields?.IsRequiredPersonalInformation
      }
    );
  }

  getOpenData() {
    this.service.getListTopN('OpenDataList', 0, true, 'GUID', this.guid).pipe(takeUntil(this.destroy$)).subscribe(
      (data: ResearchAndReportList[]) => {
          this.id = data[0].ItemId;
          this.url = data[0].ItemFields.FileLink?.Url.replace(environment.imptempPublicUrl, environment.imgPublicUrl);
          this.urlJSON = data[0].ItemFields.FileLinkJSON?.Url.replace(environment.imptempPublicUrl, environment.imgPublicUrl);
          this.urlCSV = data[0].ItemFields.FileLinkCSV?.Url.replace(environment.imptempPublicUrl, environment.imgPublicUrl);
          this.urlSPSS = data[0].ItemFields.FileLinkSPSS?.Url.replace(environment.imptempPublicUrl, environment.imgPublicUrl);
          this.urlExcel = data[0].ItemFields.FileLinkExcel?.Url.replace(environment.imptempPublicUrl, environment.imgPublicUrl);
          this.DocTitle = data[0].ItemFields.ODTitle;
          this.IsRequiredPersonalInformation = data[0].ItemFields.IsRequiredPersonalInformation;
      }
    );
  }

  putVisitNo(itemId: string) {
    this.service.putVisitingCount('opendatalist', itemId).subscribe();
  }

  getdeviceInfo() {

    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
  }

  send() {
    this.submitted = true;
    this.nameF = this.name != '';
    this.emailV = this.email != '';
    this.mobileF = this.mobile != '';
    this.whyF = this.why != '';

    if (this.email != '') {
      let pattern = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$");
      let valid = pattern.test(this.email);
      if (valid) {
        this.emailForm = true;
      } else { this.emailForm = false; }
    }

    if (this.mobile != '') {
      let pattern1 = new RegExp("^05[0-9]{8}$");
      let valid1 = pattern1.test(this.mobile);
      if (valid1) {
        this.mobileForm = true;
      } else { this.mobileForm = false; }
    }
    // if (this.nameF && this.emailV && this.mobileF && this.whyF) {
    if ( this.emailV && this.emailForm ) {
      this.service.putDowoadFile(this.name, this.mobile, this.email, this.why + '***' + this.url + '***' + this.ipAddress).subscribe();
      this.canDownload = true;
    }
  }

  // getIPAddress() {

  //   this.http.get("https://jsonip.com/").subscribe((res: any) => {
  //     this.ipAddress = res.ip;
  //   });
  // }

  /** Component events  */
  async ngOnInit() {
    this.getdeviceInfo();
    //this.getIPAddress();

    if(this.type == 'research'){
      this.getResearchReportList();
    }
    if(this.type == 'opendata'){
      this.getOpenData();
    }
    this.emailResource = await this.apiRersources.getByKey("email");
    this.mobilenumber = await this.apiRersources.getByKey("mobilenumber");
    this.invalidmobilenumber = await this.apiRersources.getByKey("invalidmobilenumber");
    this.downloadpurpose = await this.apiRersources.getByKey("downloadpurpose");
    this.requiredfield = await this.apiRersources.getByKey("requiredfield");
    this.invalidemail = await this.apiRersources.getByKey("invalidemail");
    this.reportdownload = await this.apiRersources.getByKey("reportdownload");
    this.home = await this.apiRersources.getByKey("home");
    this.nametxt = await this.apiRersources.getByKey("name");
    (this.IsRequiredPersonalInformation) ? this.Title.setTitle(this.downloadpurpose) : this.Title.setTitle(this.reportdownload);
  }


}
